const styles = theme => ({
  paperCardFrame: {
    borderRadius: '0px',
    marginBottom: '24px',
  },
  title: {
    fontWeight: '600',
    marginBottom: '5px',
  },
  innerCard: {
    padding: '12px 16px',
  },
  inputGridContainer: {
    width: '100%',
    padding: '16px',
  },
  inputGridContainer2: {
    width: '100%',
    padding: '16px',
  },
  fetchTextField: {
    display: 'grid',
    gridTemplateColumns: '10fr 2fr',
    columnGap: '16px',
    marginBottom: '16px',
    alignItems: 'center',
    '& button': {
      fontSize: '16px',
      background: theme.palette.primary.main,
      padding: '0.8em',
      height: '56px !important',
      borderRadius: '0px !important',
      textTransform: 'Capitalize',
      minWidth: '185px !important',
      '&:hover': {
        backgroundColor: theme.palette.primary.adgmHover,
        color: theme.palette.primary.white,
        border: 'none',
      },
    },
  },
  infoAlert: {
    color: '#484456',
    fontSize: '14px',
    '& svg': {
      marginInlineEnd: '4px',
    },
  },
  mediumButton: {
    fontSize: '16px',
    fontWeight: 600,
    textTransform: 'none',
    minWidth: '107px !important',
    height: '48px',
    padding: '16px 24px !important',
    '&:disabled': {
      backgroundColor: `${theme.palette.primary.black20} !important`,
      color: `${theme.palette.primary.white} !important`,
    },
  },
  fieldInfo: {
    marginTop: '6px',
    fontWeight: 'normal',
  },
  subPanel: {
    padding: '0px 24px',
    '& button': {
      minWidth: 'max-content',
      height: '48px',
      padding: '16px 40px',
    },
  },
  infoAlertBorder: {
    paddingTop: '10px',
    // borderBottom: "1px solid #CED1D6",
  },
  modalFooter: {
    borderTop: '1px solid #CED1D6',
    // marginTop: "30px",
    textAlign: 'right',
    paddingTop: '16px',
  },
  addBuyerButton: {
    borderRadius: '0px !important',
    background: theme.palette.primary.main,
    color: theme.palette.primary.white,
    '&:hover': {
      backgroundColor: theme.palette.primary.adgmHover,
      border: 'none',
    },
  },
  adgmTextField: {
    alignItems: 'stretch',
    '& > div': {
      alignItems: 'stretch',
      paddingRight: '0',
    },
    '& fieldset': {
      border: '1px solid #CED1D6',
      borderRadius: '10px',
    },
  },
  '@media (max-width: 645px)': {
    fetchTextField: {
      gridTemplateColumns: 'auto',
      columnGap: '6px',
      rowGap: '16px',
      '& button': {
        fontSize: '14px',
      },
    },
    panelTitle: {
      '& h6': {
        fontSize: '16px',
      },
    },
  },
  '@media (max-width:767px)': {
    paperCardFrame: {
      border: '0',
      borderRadius: '0',
    },
    inputGridContainer: {
      width: '100% !important',
    },
  },
  '@media (min-width: 768px)': {
    inputGridContainer: {
      padding: '16px 24px',
    },
    inputGridContainer2: {
      padding: '16px 24px',
    },
  },
  '@media (min-width: 992px)': {
    innerCard: {
      padding: '24px',
    },
  },
  // new
  inputField: {
    display: 'flex',
    color: 'red',
  },
  cancelModal: {
    display: 'none',
  },
  modalSubtitle: {
    display: 'none',
  },
  [theme.breakpoints.down('sm')]: {
    subPanel: {
      padding: '0px 28px 0px 16px',
      '& button': {
        minWidth: 'max-content',
        height: '48px',
      },
    },
    modalFooter: {
      position: 'fixed',
      bottom: '0',
      right: '0',
      left: '0',
      width: '100%',
      // height: "75px",
      borderTop: '3px solid #EBEEF3',
      backgroundColor: '#fff',
      '& button:first-child': {
        // display: "none",
        width: '50%',
      },
      '& button:last-child': {
        width: '50%',
        marginLeft: '24px',
        // margin: "auto",
      },
    },
    cancelModal: {
      display: 'block',
      position: 'absolute',
      top: '1.9rem',
      cursor: 'pointer',
      right: '1rem',
    },
    modalSubtitle: {
      display: 'block',
      background: '#F8F8F8',
      color: theme.palette.primary.adgmBlack,
      lineHeight: '24px',
      fontWeight: '600',
      padding: '10px 24px',
    },
  },
});

export default styles;
